import { __read, __spreadArray } from "tslib";
import { checkSSR, warnLogger } from './utils';
/**
 * ChannelIO SDK.
 *
 * @link https://developers.channel.io/docs/web-channel-io
 */
export var ChannelIO = function (method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (checkSSR()) {
        return;
    }
    if (typeof window.ChannelIO !== 'function') {
        warnLogger('ChannelIO instance is not initalized yet.');
        return;
    }
    window.ChannelIO.apply(window, __spreadArray([method], __read(args)));
};
